// Shared design tokens for the Analyst workbench UI.
//
// Dark mode uses the EXACT palette from the approved design sketch
// (local/05-combined.html); light mode maps the same roles onto warm
// paper equivalents. All Analyst components pull from here so the
// surfaces stay consistent.

export const surfacesFor = (t) => (t.palette.mode === 'dark' ? {
  ink:     '#0a0c0a',   // page canvas
  rail:    '#101210',   // chat-logs sidebar + header bar
  panel:   '#141614',   // receipts, cards (bottom of gradient)
  panel2:  '#1a1d1a',   // bubbles, composer, cards (top of gradient)
  border:  '#252a25',
  border2: '#313731',
  text:    '#e9ede7',
  muted:   '#96a096',
  faint:   '#6b756b',
  dot:     '#1b201b',   // dot-grid texture
  codeBg:  '#111411',
  danger:  '#ff8a80',
} : {
  ink:     '#f6f5f0',
  rail:    '#fbfaf7',
  panel:   '#ffffff',
  panel2:  '#ffffff',
  border:  '#e5e3da',
  border2: '#d6d4c9',
  text:    t.palette.text.primary,
  muted:   t.palette.text.secondary,
  faint:   '#8a8f85',
  dot:     '#ddd8cb',
  codeBg:  '#111411',
  danger:  t.palette.error.main,
});

// Series palette for charts - the sketch draws "actual" in soft teal
// and "forecast"/highlights in lime; extra series continue with the
// insight-card accent colors.
export const chartPaletteFor = (t) => (t.palette.mode === 'dark'
  ? ['#5ee6d0', '#c0fb6e', '#d29bff', '#ffb45e', '#7fb2ff', '#ff7a6b']
  : ['#197563', '#6cb31f', '#8e5bd1', '#d97f1f', '#3b6fd4', '#d95f52']);

// Header-style initials (first + last word), identical to the global
// Header avatar so the two read as the same identity.
export const initialsOf = (nameOrEmail) => {
  const name = String(nameOrEmail || '').trim();
  if (!name) return '?';
  const parts = name.split(/\s+/).filter(Boolean);
  const first = parts[0]?.[0] || '';
  const last = parts.length > 1 ? parts[parts.length - 1][0] : '';
  return (first + last).toUpperCase() || name[0].toUpperCase();
};
